export default "__VITE_ASSET__16d3b01a__"